import { useState, useEffect } from 'react';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type DeferredPrompt = any;

export default function InstallPWA() {
    const [prompt, setPrompt] = useState<DeferredPrompt>(null);
    const [dismissed, setDismissed] = useState(false);

    useEffect(() => {
        if (sessionStorage.getItem('pwa-banner-dismissed')) {
            setDismissed(true);
            return;
        }
        const handler = (e: Event) => {
            e.preventDefault();
            setPrompt(e);
        };
        window.addEventListener('beforeinstallprompt', handler);
        return () => window.removeEventListener('beforeinstallprompt', handler);
    }, []);

    if (!prompt || dismissed) return null;

    const handleInstall = async () => {
        const p = prompt as { prompt: () => Promise<void>; userChoice: Promise<{ outcome: string }> };
        await p.prompt();
        const { outcome } = await p.userChoice;
        if (outcome === 'accepted' || outcome === 'dismissed') {
            setPrompt(null);
            setDismissed(true);
        }
    };

    const handleDismiss = () => {
        sessionStorage.setItem('pwa-banner-dismissed', '1');
        setDismissed(true);
    };

    return (
        <div className="fixed bottom-4 left-4 right-4 z-50 md:left-auto md:right-6 md:w-80">
            <div className="bg-slate-800 border border-slate-700 rounded-2xl p-4 shadow-2xl flex items-center gap-3">
                <div className="flex-shrink-0 w-10 h-10 bg-primary/20 rounded-xl flex items-center justify-center">
                    <span className="material-symbols-outlined text-primary text-xl">install_mobile</span>
                </div>
                <div className="flex-1 min-w-0">
                    <p className="text-sm font-semibold text-white">Instalar Diana IA</p>
                    <p className="text-xs text-slate-400">Acceso rápido desde tu pantalla</p>
                </div>
                <div className="flex gap-2 flex-shrink-0">
                    <button
                        onClick={handleDismiss}
                        className="text-slate-500 hover:text-slate-300 transition-colors"
                        aria-label="Cerrar"
                    >
                        <span className="material-symbols-outlined text-lg">close</span>
                    </button>
                    <button
                        onClick={handleInstall}
                        className="px-3 py-1.5 bg-primary hover:bg-primary/90 text-white text-xs font-semibold rounded-xl transition-colors"
                    >
                        Instalar
                    </button>
                </div>
            </div>
        </div>
    );
}
